export enum TipoModificacionCliente {
    Cliente = 0,
    Cuenta = 1
}